import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { bindActionCreators, compose } from 'redux'
import PreviewTemplate from '../PreviewTemplate'

import * as UserActions from '../../store/user/actions'

import { _route } from '../../routes/config'

interface INativeProps {}

interface IReduxStateProps {
  currentPatientId: string
}

interface IReduxDispatchProps {
  PatientsLib: any
  UserLib: any
}

interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}

interface IProps extends INativeProps, IReduxProps, RouteComponentProps {}

class WelcomeScreen extends React.Component<IProps> {
  componentDidMount() {
    const { UserLib } = this.props

    const oobCode = this.getOobCode()

    if (oobCode) {
      UserLib.verifyUser(
        oobCode,
        () => {
          return
        },
        error => {
          console.log('welcome screen fails', error)
        }
      )
    }
  }

  getOobCode(): string | null {
    const {
      location: {}
    } = this.props

    return new URL(location.href).searchParams.get('oobCode')
  }

  render() {
    const { history } = this.props
    return (
      <PreviewTemplate
        buttonText="CREATE CHILD PROFILE"
        buttonClick={() => {
          history.replace(_route.child.list)
        }}
        title="Welcome to your parent interface"
        text={
          <>
            This is where you will manage your children’s profiles, monitor
            their evaluation progress, view their evaluation results, and go
            over personalized suggestions that will be provided for them
          </>
        }
        showStars={false}
        showChild={true}
        textStyles={{ width: '43.625rem', maxWidth: '100%' }}
      />
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    UserLib: bindActionCreators<any, any>(UserActions as any, dispatch)
  }
}

const connector = connect(null, mapDispatchToProps)

export default compose(withRouter, connector)(WelcomeScreen)



// WEBPACK FOOTER //
// ./src/pages/WelcomeScreen/index.tsx